import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { navigate } from "gatsby";
import urlBuilder from "@sanity/image-url";
import { ArticlePreview } from "../../../interfaces/sanity/sanityClasses";
import { getArticleCategory } from "../../../utils/sanity";
import COLORS from "../../../constants/colors";
import sanity from "../../../constants/sanity";

interface Props {
  article: ArticlePreview;
}

const ArticleCard = ({ article }: Props) => {
  if (!article.previewImage && !article.mainImage) {
    // eslint-disable-next-line no-console
    console.warn("No valid image source found for article:", article);
  }
  return (
    <Card
      sx={{
        backgroundColor: "transparent",
        borderRadius: "16px",
        display: "flex",
        flex: 1,
        "&:hover": {
          "& .MuiCardContent-root": {
            backgroundColor: COLORS.BRIGHT_BLUE[40],
          },
        },
      }}
    >
      <CardActionArea
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
        LinkComponent="a"
        onClick={() => {
          navigate(`/artikler/${article.slug.current}`);
        }}
      >
        <CardMedia
          component="img"
          height="200"
          image={urlBuilder()
            .image(article.previewImage ?? article.mainImage)
            .projectId(sanity.PROJECT_ID)
            .dataset("blogg")
            .fit("fill")
            .format("webp")
            .auto("format")
            .quality(100)
            .width(356)
            .height(199)
            .url()}
          alt="Kampanjebilde"
          style={{
            display: "block",
            width: "100%",
            aspectRatio: "1.8",
          }}
        />
        <CardContent
          sx={{
            backgroundColor: COLORS.WHITE[100],
            display: "flex",
            flex: 1,
            width: "100%",
            padding: "24px",
            paddingBottom: "32px",
          }}
        >
          <Stack alignItems="flex-start" display="flex" flex={1} gap="8px">
            <Chip
              label={getArticleCategory(article)}
              color="secondary"
              sx={{
                borderRadius: 0,
                backgroundColor: "transparent",
                ":hover": { backgroundColor: COLORS.BRIGHT_BLUE[40] },
                border: "1px solid",
              }}
            />
            <Typography
              color={COLORS.BLACK[100]}
              variant="articleCardTitle"
              component="u"
              sx={{
                overflow: "hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "2",
                "-webkit-box-orient": "vertical",
              }}
            >
              {article.title} →
            </Typography>
            <Typography
              color={COLORS.BLACK[100]}
              sx={{
                overflow: "hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "2",
                "-webkit-box-orient": "vertical",
              }}
            >
              {article.excerpt}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ArticleCard;
